import { 
    SET_PAGE_TITLE, 
    SET_BODY_CLASS, 
    SHOW_APP_LOADER, 
    HIDE_APP_LOADER, 
    HIDE_MOBILE_NAV
} from './mutation-types';

export default {
    /**
     * This action sets the page title depending on the current route
     */
    setPageTitle({ commit }, title) {
        commit(SET_PAGE_TITLE, title);
    },

    /**
     * This action sets the page title depending on the current route
     */
    hideMobileNav({ commit }) {
        commit(HIDE_MOBILE_NAV);
    },

	/**
	 * This action sets the class for the body. It is used 
     * for various styling
	 */
	setBodyClass({ commit }, newClass) {
		commit(SET_BODY_CLASS, newClass);
	},

    /**
     * This action shows the app's loader which is needed whenever
     * the app is doing something asynchronously.
     */
    showLoader({ commit }) {
        commit(SHOW_APP_LOADER);
    },

    /**
     * This action hides the app's loader
     */
    hideLoader({ commit }) {
        commit(HIDE_APP_LOADER);
    }
}


// WEBPACK FOOTER //
// ./src/store/actions.js